import React from 'react';
import ProjectsList from './ProjectsList';
import ProjectDetails from './ProjectDetails';

const CompletedProjectsView = ({
  projects = [],
  selectedProject,
  onSelectProject,
  onUpdateProject,
  onDeleteProject,
  onCreateTask,
  onUpdateTask,
  onDeleteTask,
  onAddNote,
  isSubmitting,
  showNotification
}) => {
  // Filter projects to show completed and cancelled ones
  const completedProjects = projects.filter(project => ['completed', 'cancelled'].includes(project.status));

  return (
    <>
      {/* Completed Projects List - Left Panel */}
      <ProjectsList
        projects={completedProjects}
        selectedProject={selectedProject}
        onSelectProject={onSelectProject}
        onCreateProject={null} // Disable project creation in completed view
        onUpdateProject={onUpdateProject}
        isSubmitting={isSubmitting}
        hideCreateButton={true}
        title="Completed"
      />

      {/* Project Details - Right Panel */}
      <ProjectDetails
        selectedProject={selectedProject}
        onUpdateProject={onUpdateProject}
        onDeleteProject={onDeleteProject}
        onCreateTask={onCreateTask}
        onUpdateTask={onUpdateTask}
        onDeleteTask={onDeleteTask}
        onAddNote={onAddNote}
        isSubmitting={isSubmitting}
        showNotification={showNotification}
      />
    </>
  );
};

export default CompletedProjectsView;